import { render } from "./MoreList.vue?vue&type=template&id=4a7ba288"
import script from "./MoreList.vue?vue&type=script&lang=js"
export * from "./MoreList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__